export default "__VITE_ASSET__lrJfkIty__"